// Only server-created v2 pairs have a thumbnail. Existing uploads keep their exact URL.
export function medicationThumbnailUrl(src) {
    try {
        const url = new URL(src);
        if (url.protocol !== 'https:' || url.hostname !== 'firebasestorage.googleapis.com') return src;
        const prefix = url.pathname.match(/^\/v0\/b\/[^/]+\/o\//)?.[0];
        if (!prefix) return src;
        const path = decodeURIComponent(url.pathname.slice(prefix.length));
        if (!/^pill-reminder\/medications\/\d+\/\d+\/v2\/[0-9a-f-]{36}\/full\.jpg$/.test(path)) return src;
        url.pathname = prefix + encodeURIComponent(path.replace(/full\.jpg$/, 'thumb.jpg'));
        return url.toString();
    } catch { return src; }
}
